import { render } from "./LessonDogsTopic3.vue?vue&type=template&id=1372e28a"
import script from "./LessonDogsTopic3.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__